import type {
  ComponentSpec,
  ProcessedWidgetData,
  WidgetResponseSpec,
} from "./types";
import { getWidgetCore } from "../Definitions/core";

/**
 * Process a widget through the full pipeline.
 * Delegates to the process function of the widget core (Definitions/core), so this
 * module never imports a widget component.
 * Results are deterministic for the same inputs and safe to cache.
 */
export function processWidget(
  spec: ComponentSpec,
  response: WidgetResponseSpec | null,
): ProcessedWidgetData {
  const def = getWidgetCore(spec.type);
  if (!def?.process) {
    throw new Error(`No processor registered for widget type: ${spec.type}`);
  }
  return def.process(spec, response);
}
